<template>
	<div>
		<v-card>
			<v-card-title>
				<v-btn icon @click="newEntry" class="ml-0 mr-3">
					<v-icon>add_circle</v-icon>
				</v-btn>

				<v-text-field
					v-model="search"
					label="Поиск"
					clearable
					class="mb-4"
					single-line
					hide-details>
				</v-text-field>

				<v-btn small :color="hideStorned ? 'primary' : 'secondary'" @click="showStorned" class="ma-2">
					{{ hideStorned ? 'Показать сторнированные' : 'Скрыть сторнированные' }}
				</v-btn>
				<v-btn small :color="!filtersApplied ? 'primary' : 'secondary'" @click="showFilter" class="ma-2">
					{{ filtersApplied ? 'Сбросить фильтры' : filter ? 'Скрыть фильтры' : 'Показать фильтры' }}
				</v-btn>

			</v-card-title>

			<v-data-table
				:headers="headers"
				:items="data"
				:items-per-page="-1"
				:loading="loading"
				hide-default-footer
				hide-default-header
				:mobile-breakpoint="0"
				show-expand
				single-expand
				no-data-text=""
				:expanded.sync="expanded"
				item-key="id">
				<template v-slot:header="props">
					<thead>
						<tr v-if="filter">
							<th></th>
							<th v-for="header in headers"
								:key="header.value"
								class="pa-0"
							>
								<template v-if="header.filterable && header.filterType == 'text'">
									<v-row align-content="center" justify="center">
										<v-col cols="12" class="px-5 pt-0">
											<v-text-field
												v-model="header.filterValue"
												:label="header.text"
												class="body-2 elevation-1"
												hide-details
												filled
												clearable>
											</v-text-field>
										</v-col>
									</v-row>
								</template>

								<template v-if="header.filterable && header.filterType == 'number'">
									<v-row align-content="center" justify="center">
										<v-col cols="6" class="pl-5 pt-0 pr-1" >
											<v-text-field
												label="От"
												v-model="header.filterValue.from"
												class="body-2 elevation-1"
												hide-details
												filled
												clearable
												>
											</v-text-field>
										</v-col>
										<v-col cols="6" class=" pr-5 pt-0 pl-1" >
											<v-text-field
												label="До"
												v-model="header.filterValue.to"
												class="body-2 elevation-1"
												hide-details
												filled
												clearable
												>
											</v-text-field>
										</v-col>
									</v-row>
								</template>
							</th>
						</tr>
						<tr v-else>
							<th></th>
							<th	v-for="header in headers"
								:key="header.value"
								class="text-center">
									{{ header.text }}
							</th>
						</tr>
					</thead>
				</template>
				<template v-slot:item="props">
					<tr :ref="'line' + props.item.id" @click="clickRow(props.item)">
						<td class="text-center">
							<v-icon>{{ isExpanded(props.item) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
						</td>
						<td class="text-center">
							{{ props.item.year }}
						</td>
						<td class="text-center">
							{{ props.item.mon }}
						</td>
						<td class="text-center">
							{{ props.item.dcn }}
						</td>
						<td class="text-center">
							{{ props.item.icn }}
						</td>
						<td class="text-right">
							{{ props.item.value }}
						</td>
						<td class="text-center">
							{{ props.item.statusText }}
						</td>
						<td class="nowrap text-center">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-icon
										v-if="props.item.status == 0 && props.item.storno == 0"
										small
										v-on="on"
										class="mr-2 tr-hover"
										@click.stop="edit(props.item)">
										edit
									</v-icon>
								</template>
								<span>Редактировать</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-icon
										small
										v-on="on"
										class="mr-2 tr-hover"
										@click.stop="copy(props.item)">
										file_copy
									</v-icon>
								</template>
								<span>Копировать</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-icon
										v-if="props.item.storno == 0 && props.item.status > 0"
										small
										v-on="on"
										class="mr-2 tr-hover"
										@click.stop="storno(props.item)">
										replay
									</v-icon>
								</template>
								<span>Сторнировать</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-icon
										v-if="props.item.status == 0 && props.item.storno == 0"
										small
										v-on="on"
										class="mr-2 tr-hover"
										@click.stop="del(props.item)">
										delete
									</v-icon>
								</template>
								<span>Удалить</span>
							</v-tooltip>
						</td>
					</tr>
				</template>
				<template v-slot:expanded-item="props">
					<td :colspan="props.headers.length" class="pa-0">
				        <v-card tile dark>
							<v-row class="ma-0">
								<v-col cols="6">
						            <v-list dense>
										<v-list-item>
											<v-list-item-content>Дата записи</v-list-item-content>
											<v-list-item-content class="align-end">
												{{ props.item.reportedAt }}
											</v-list-item-content>
										</v-list-item>
						              	<v-list-item>
							                <v-list-item-content>Автор</v-list-item-content>
							                <v-list-item-content class="align-end">
												{{ props.item.reportedBy }}
											</v-list-item-content>
						            	</v-list-item>
						              	<v-list-item>
							                <v-list-item-content>Комментарий</v-list-item-content>
							                <v-list-item-content class="align-end">
												{{ props.item.comment }}
											</v-list-item-content>
						            	</v-list-item>
									</v-list>
								</v-col>
							</v-row>
							<v-card-actions v-if="props.item.storno > 0" @click="goToPair(props.item.storno)">
								<v-btn small text>
									Перейти к парной проводке
								</v-btn>
							</v-card-actions>
				        </v-card>
					</td>
			    </template>
				<template v-slot:body.append="{ headers }">
					<tr>
						<td colspan="5" class="nowrap text-left">
							Итого
						</td>
						<td class="nowrap text-right">
							{{ total }}
						</td>
						<td colspan="2"></td>
					</tr>
				</template>
			</v-data-table>
		</v-card>
		<v-dialog
			v-model="dialog.show"
			persistent
			max-width="1200">
			<v-card>
				<v-card-title>
					{{ dialog.new ? 'Создание резерва' :
						(dialog.storno ? 'Сторно резерва' : 'Корректировка резерва') }}
				</v-card-title>
				<v-form ref="f" v-model="dialog.valid">
		          	<v-card-text>
		            	<v-container>
		              		<v-row justify="start">
								<v-col cols="12" v-if="dialog.storno">
									<p>
										Вы собираетесь сторнировать резерв за период {{ dialog.stornoPeriod }}. Выберите период, в котором будет проведена корректирующая проводка.
									</p>

									<p>
										<span class="red--text text--lighten-1">NB:</span> Сторно резерва невозможно отменить!
									</p>
								</v-col>
								<v-col cols="6">
									<v-subheader>Месяц</v-subheader>
									<v-date-picker
										v-model="dialog.item.month"
										type="month"
										landscape
										required
										reactive
										locale="ru-ru"
										:min="minMonth"
										:show-current="false"
										full-width>
									</v-date-picker>
								</v-col>
								<v-col cols="6">
									<v-row>
										<v-col cols="12">
				                  			<v-autocomplete
												v-model="dialog.item.dc"
												:items="dc"
												:rules="[rules.required]"
												:disabled="dialog.storno"
												item-value="code"
												item-text="name"
												@change="getIc"
												label="Отдел">
											</v-autocomplete>
				                		</v-col>
				                		<v-col cols="12">
											<v-autocomplete
												v-model="dialog.item.ic"
												:items="ic"
												:rules="[rules.required]"
												:disabled="dialog.storno"
												item-value="code"
												item-text="name"
												label="Статья">
											</v-autocomplete>
				                		</v-col>
				                		<v-col cols="12">
				                  			<a-number-field
												v-model="dialog.item.value"
												validate-on-blur
												:rules="[rules.required]"
												:disabled="dialog.storno"
												label="Сумма">
											</a-number-field>
				                		</v-col>
				                		<v-col cols="12">
				                  			<v-textarea
												v-model="dialog.item.comment"
												validate-on-blur
												label="Комментарий">
											</v-textarea>
				                		</v-col>
									</v-row>
								</v-col>
		              		</v-row>
		            	</v-container>
		          	</v-card-text>
				</v-form>

		        <v-card-actions>
					<v-btn
						text
						@click="add"
						:loading="dialog.loading"
						:disabled="!dialog.valid || dialog.loading"
						v-if="dialog.new">
						Добавить
					</v-btn>
					<v-btn
						text
						@click="add"
						:loading="dialog.loading"
						:disabled="!dialog.valid || dialog.loading"
						v-else-if="dialog.storno">
						Сторно
					</v-btn>
					<v-btn
						text
						@click="save"
						:loading="dialog.loading"
						:disabled="!dialog.valid || dialog.loading"
						v-else>
						Сохранить
					</v-btn>
		            <v-btn text @click="close">Отмена</v-btn>
		        </v-card-actions>
        	</v-card>
		</v-dialog>
	</div>
</template>

<style scoped>
	.nowrap {
		white-space: nowrap;
	}
</style>

<script>
	import aNumberField from '../base/ANumberField.vue'
	import {toStr, toNum} from '../../js/common.js'
	import {api} from '../../lib/api'
	import _ from 'lodash'

	export default {
		components: {
			aNumberField
		},
		props: {
			hotelCode: String,
			minMonth: String
		},
		data: () => ({
			headers: [
				{
					text: 'Год',
					value: 'year',
					align: 'center',
					filterable: true,
					filterType: 'text',
					filterValue: '',
				},
				{
					text: 'Месяц',
					value: 'mon',
					align: 'center',
					filterable: true,
					filterType: 'text',
					filterValue: '',
				},
				{
					text: 'Отдел',
					value: 'dcn',
					align: 'center',
					filterable: true,
					filterType: 'text',
					filterValue: '',
				},
				{
					text: 'Статья',
					value: 'icn',
					align: 'center',
					filterable: true,
					filterType: 'text',
					filterValue: '',
				},
				{
					text: 'Сумма (РУБ)',
					value: 'value',
					align: 'center',
					filterable: true,
					filterType: 'number',
					filterValue: {
						from: '',
						to: ''
					},
				},
				{
					text: 'Статус',
					value: 'status',
					align: 'center',
					filterable: true,
					filterType: 'text',
					filterValue: '',
				},
				{
					text: 'Действия',
					value: 'actions',
					align: 'center',
					filterable: false,
					filterType: 'text',
					filterValue: '',
				},
			],
			data: [],
			loading: false,
			loadedAll: false,
			filter: false,
			search: '',
			hideStorned: true,
			dialog: {
				show: false,
				index: 0,
				valid: false,
				new: false,
				storno: false,
				stornoId: 0,
				stornoPeriod: '',
				loading: false,
				month: '',
				item: {
					value: 0,
					month: '',
					dc: 0,
					ic: 0,
					comment: '',
				}
			},
			rules: {
	          	required: value => value !== "" || 'Обязательно'
	        },
			dc: [],
			ic: [],
			dcLoaded: false,
			expanded: [],
		}),
		computed: {
			total() {
				return this.data.reduce((acc, cur) => toStr(toNum(acc) + toNum(cur.value)), 0)
			},
			filtersApplied() {
				return Object.keys(this.filters).length > 1
			},
			filters() {
				let filters = {
					search: this.search
				}

				this.headers.forEach(header => {
					if (header.filterable) {
						if (header.filterType == 'text' && header.filterValue) {
							filters[header.value] = header.filterValue
						}
						else if (header.filterType == 'date'
							&& (
								header.filterValue.fromDate
								|| header.filterValue.toDate
							)
						) {
							filters[header.value] = header.filterValue
						}
						else if (header.filterType == 'number'
							&& (
								header.filterValue.from
								|| header.filterValue.to
							)
						) {
							filters[header.value] = header.filterValue
						}
					}
				})

				return filters
			},
		},
		created() {
			this.throttledLoadReserves = _.throttle(this.loadReserves, 1000)
			this.debouncedLoadReserves = _.debounce(this.loadReserves, 1000)
			this.loadReserves()
		},
		mounted() {
			window.onscroll = () => {
				let scrolled = document.documentElement.scrollTop + window.innerHeight > document.documentElement.offsetHeight - 500
				if (scrolled) this.throttledLoadReserves()
			}
		},
		watch: {
			filters: {
				handler: function () {
					this.data = []
					this.loadedAll = false
					this.debouncedLoadReserves()
				},
				deep: true
			},
			hotelCode(val) {
				this.data = []
				this.loadedAll = false
				this.loadReserves()
			}
		},
		methods: {
			clickRow (row) {
				let i = this.expanded.indexOf(row)
				if (i >= 0) {
					this.expanded.splice(i, 1)
				}
				else {
					this.expanded = []
					this.expanded.push(row)
				}
			},
			isExpanded (row) {
				return this.expanded.indexOf(row) >= 0
			},
			showFilter () {
				this.filter = !this.filter
				this.headers.forEach(header => {
					if (header.filterable) {
						if (header.filterType == 'text') {
							header.filterValue = ''
						}
						else if (header.filterType == 'number') {
							header.filterValue.from = ''
							header.filterValue.to = ''
						}
					}
				})
			},
			showStorned () {
				this.hideStorned = !this.hideStorned
				this.data = []
				this.loadedAll = false
				this.loadReserves()
			},
			loadReserves () {
				if (!this.loadedAll && !this.loading) {
					this.loading = true
					// console.log('loadReserves')

					api.post('reserves/get_reserves', {
						hotelCode: this.hotelCode,
						offset: this.data.length,
						filters: this.filters,
						hideStorned: this.hideStorned
					})
					.then(response => {
						// if (response.data.length) {
						// 	console.log('loadReserves Response', response.data.data[0].id, response.data.data[response.data.data.length - 1].id)
						// }
						// else {
						// 	console.log('loadReserves Response - []')
						// }

						response.data.data.forEach(r => this.data.push(r))
						this.loadedAll = response.data.all
						this.loading = false

					}, error => {})
				}
			},
			getDc() {
				if (!this.dcLoaded) {
					api.post('common/get_dc', {
						pl: false,
						mult: false,
						nameFormat: 'id: rusName / engName'
					})
					.then(response => {

						this.dc = response.data.data
						this.dcLoaded = true

					}, error => {})
				}
			},
			getIc() {
				api.post('common/get_ic', {
					dc: this.dialog.item.dc,
					mult: false,
					open_to_input: true,
					nameFormat: 'code: rus_name / eng_name'
				})
				.then(response => {
					this.ic = response.data.data
				}, error => {})
			},
			newEntry() {
				this.getDc()
				this.dialog.index = 0
				this.dialog.new = true
				this.dialog.storno = false
				this.dialog.stornoId = 0
				this.dialog.stornoPeriod = ''
				this.dialog.item = {
					id: 0,
					dc: '',
					ic: '',
					value: '',
					month: new Date().toISOString().substr(0, 7),
					comment: '',
				}
				this.dialog.show = true
				if (this.$refs.f !== undefined) {
					this.$refs.f.resetValidation()
				}
			},
			copy(item) {
				this.getDc()
				this.dialog.index = 0
				this.dialog.new = true
				this.dialog.storno = false
				this.dialog.stornoId = 0
				this.dialog.stornoPeriod = ''
				this.dialog.item = Object.assign(this.dialog.item, item)
				this.dialog.item.dc = this.dialog.item.dcn.split(' ')[0]
				this.dialog.item.ic = this.dialog.item.icn.split(' ')[0]
				this.dialog.item.month = this.dialog.item.year + '-' + this.dialog.item.mon.padStart(2, '0')

				if (new Date(this.dialog.item.month) < new Date(this.minMonth)) {
					this.dialog.item.month = this.minMonth
				}

				this.getDc()
				this.getIc()

				if (this.$refs.f !== undefined) {
					this.$refs.f.validate()
				}

				this.dialog.show = true
			},
			del(item) {
				this.$store.dispatch('dialogConfirm', {
					title: 'Удаление резерва',
					message: 'Удалить резерв: <br><br> - '
						+ item.year + '-' + item.mon.padStart(2, '0') + '<br> - '
						+ item.dcn + '<br> - ' + item.icn
						+ '<br> - ' + item.value
						+ ' руб.<br><br>?'
				})
				.then(confirm => {
					if (confirm) {
						let index = this.data.indexOf(item)
						api.post('reserves/delete_entry', {
							id: item.id
						})
						.then(response => {

							this.data.splice(index, 1)

						}, error => {})
					}
				})
			},
			storno(item) {
				this.getDc()
				this.dialog.index = 0
				this.dialog.new = false
				this.dialog.storno = true
				this.dialog.stornoId = item.id
				this.dialog.stornoPeriod = item.year + '-' + item.mon.padStart(2, '0')
				this.dialog.item = Object.assign(this.dialog.item, item)
				this.dialog.item.dc = this.dialog.item.dcn.split(' ')[0]
				this.dialog.item.ic = this.dialog.item.icn.split(' ')[0]
				this.dialog.item.month = this.minMonth
				this.dialog.item.value = '-' + this.dialog.item.value

				this.getDc()
				this.getIc()

				if (this.$refs.f !== undefined) {
					this.$refs.f.validate()
				}

				this.dialog.show = true
			},
			add() {
				if (!this.dialog.valid) return

				this.dialog.loading = true

				let item = this.dialog.item

				let params = {
					dc: item.dc,
					ic: item.ic,
					month: item.month,
					value: item.value,
					comment: item.comment,
					hotelCode: this.hotelCode,
					type: 2
				}

				if (this.dialog.storno) {
					params.storno = this.dialog.stornoId
				}

				api.post('reserves/add_entry', params)
				.then(response => {


					let newItem = Object.assign({}, item, response.data.entry)
					this.data.unshift(newItem)

					// this.data.unshift(item)
					// Object.assign(this.data[0], response.data.entry)

					if (this.dialog.storno) {
						let storntedItem = this.data.find(item => item.id == this.dialog.stornoId)
						storntedItem.statusText = 'Storned'
						storntedItem.storno = response.data.entry.id
					}

					this.dialog.show = false
					this.dialog.loading = false

				}, error => {
					this.dialog.loading = false
				})
			},
			edit(item) {
				this.dialog.index = this.data.indexOf(item)
				this.dialog.new = false
				this.dialog.storno = false
				this.dialog.stornoId = 0
				this.dialog.stornoPeriod = ''
				this.dialog.item = Object.assign(this.dialog.item, item)
				this.dialog.item.month = this.dialog.item.year + '-' + this.dialog.item.mon.padStart(2, '0')
				this.dialog.item.dc = this.dialog.item.dcn.split(' ')[0]
				this.dialog.item.ic = this.dialog.item.icn.split(' ')[0]

				this.getDc()
				this.getIc()

				if (this.$refs.f !== undefined) {
					this.$refs.f.validate()
				}

				this.dialog.show = true
			},
			close() {
				this.dialog.show = !this.dialog.show
			},
			save() {
				if (!this.dialog.valid) return

				let item = this.dialog.item

				api.post('reserves/update_entry', {
					id: item.id,
					dc: item.dc,
					ic: item.ic,
					month: item.month,
					value: item.value,
					comment: item.comment
				})
				.then(response => {
					// console.log(response.data.entry)
					// console.log(this.data[this.dialog.index])

					Object.assign(this.data[this.dialog.index], response.data.entry)

					this.dialog.show = false

				}, error => {})
			},
			goToPair(id) {
				// this.clickRow(this.data.id)
				this.$vuetify.goTo(this.$refs['line' + id], {
					offset: 250
				})
				this.$refs['line' + id].click()
			},
		}
	}
</script>
